/**
 * Probe whether the current browser can create a WebGL context.
 * Bots (HeadlessChrome on Linux without GPU), very old browsers, and
 * machines with disabled GPU acceleration will return false here, and
 * the app shows a graceful WebGLGate instead of crashing the canvas.
 */
export function hasWebGL(): boolean {
  try {
    const canvas = document.createElement('canvas');
    if (!window.WebGLRenderingContext) return false;
    return !!(canvas.getContext('webgl2') || canvas.getContext('webgl'));
  } catch {
    return false;
  }
}

const BOT_UA_PATTERN =
  /HeadlessChrome|Googlebot|bingbot|YandexBot|DuckDuckBot|Slackbot|Twitterbot|Discordbot|Embedly|facebookexternalhit|LinkedInBot|WhatsApp|Telegrambot|Applebot|SkypeUriPreview|vercel-screenshot/i;

export function isLikelyBot(userAgent: string = navigator.userAgent): boolean {
  return BOT_UA_PATTERN.test(userAgent);
}
